import React from 'react';
import { SvgIcon } from './svg-icon';

export const Hamburger = props => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.2178 3.22192H7.78313C4.83503 3.22192 3 5.30311 3 8.2483V16.1955C3 19.1407 4.83503 21.2219 7.78411 21.2219H16.2178C19.1659 21.2219 21 19.1407 21 16.1955V8.2483C21 5.30311 19.1572 3.22192 16.2178 3.22192Z"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 9.22192L7 12.2237L10 15.2219"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 3.28833V21.1633"
      stroke="#64748B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
